<template>
  <div class="homeContainer" v-if="dataReady" :style="bgColorStyle">
    <!-- 顶部导航按钮 -->
    <PinnedBtnContainer>
      <component
        v-for="pinnedBtnObj in pinnedBtnComponentObjs"
        :key="pinnedBtnObj.id"
        :is="pinnedBtnObj.component"
        v-bind="pinnedBtnObj.props"
        @reportEvent="handleReport"
      ></component>
    </PinnedBtnContainer>
    <!-- 模板头图 -->
    <Banner :imgUrl="tplData.pageConfig.headImage" />
    <Main
      :bgImgUrl="tplData.pageConfig.backgroundImage"
      :bgColor="tplData.pageConfig.backgroundColor"
    >
      <!-- 流式布局组件 -->
      <FlowComponentContainer
        v-for="flowObj in flowComponentObjs"
        :key="flowObj.id"
        :hasGap="flowObj.hasGap"
      >
        <component
          :is="flowObj.component"
          v-bind="flowObj.props"
          @reportEvent="handleReport"
          :moduleName="moduleName"
        />
      </FlowComponentContainer>
    </Main>
    <!-- 固定定位组件 -->
    <component
      v-for="positionObj in positionComponentObjs"
      :key="positionObj.id"
      :is="positionObj.component"
      v-bind="positionObj.props"
      @reportEvent="handleReport"
    />
  </div>
</template>

<script>
import { isRiskError } from '../../helper';
import Main from '../components/Main';
import PinnedBtnContainer from '../../common/PinnedBtnContainer';
import FlowComponentContainer from '@/components/templates/common/FlowComponentContainer';
import { mapActions, mapState, mapMutations } from 'vuex';
import Banner from '@/components/templates/common/Banner';

export default {
  components: {
    PinnedBtnContainer,
    Banner,
    FlowComponentContainer,
    Main
  },
  props: {
    actCode: String,
    moduleName: String
  },
  data() {
    return {
      disabled: false
    };
  },
  computed: {
    ...mapState('app', {
      // 这里之所以用 this.moduleName 是为了组合模板考虑的，
      // 如果写死module名的话，同一个模板重复使用时就会命名空间冲突
      // 如果确定模板不会用于组合模板也可以写死为 app/{tplName}
      actData: function(state) {
        return state[this.moduleName].actData;
      },
      tplData: function(state) {
        return this.tplDataProp || state[this.moduleName].tplData;
      },
      positionComponentObjs: function(state) {
        return state[this.moduleName].positionComponentObjs;
      },
      flowComponentObjs: function(state) {
        return state[this.moduleName].flowComponentObjs;
      },
      pinnedBtnComponentObjs: function(state) {
        return state[this.moduleName].pinnedBtnComponentObjs;
      }
    }),
    dataReady() {
      return this.actData;
    },
    bgColorStyle() {
      if (
        this.tplData &&
        this.tplData.pageConfig &&
        this.tplData.pageConfig.backgroundColor
      ) {
        return {
          backgroundColor: this.tplData.pageConfig.backgroundColor
        };
      }
      return {};
    }
  },
  methods: {
    ...mapActions('app', {
      // mapAction 也一样需要做转换
      getActData: function(dispatch, ...props) {
        dispatch(`${this.moduleName}/getActData`, ...props);
      }
    }),
    ...mapMutations('app', {
      initSetActCode: function(commit, actCode) {
        return commit(`${this.moduleName}/initSetActCode`, actCode);
      }
    }),
    async initPage() {
      try {
        await this.getActData(this.actCode);
      } catch (error) {
        // 命中风控处理
        if (isRiskError(error.ret)) {
          this.$router.replace('/account_error');
          return;
        }
        this.$hll.toast(error && error.msg);
        return;
      }
    },
    // 埋点建议传递到最外层统一上报，方便加上 activity_id
    handleReport(data) {
      const { event, ...fields } = data;
      this.visitLog('', '', {
        ...fields,
        actEventType: event,
        activity_id: this.actCode
      });
    },
    setTitle() {
      const actName = this.tplData.pageConfig && this.tplData.pageConfig.name;
      if (actName) {
        document.title = actName;
      }
    }
  },
  async created() {
    await this.initSetActCode(this.actCode);
    await this.initPage();
    await this.setTitle();
  }
};
</script>

<style lang="less" scoped>
.homeContainer {
  padding-bottom: 160px;
}
.errorToast {
  height: 431px;
  font-size: 32px;
  color: #000;
  .fc;
}
</style>
